<template>
  <div class="main_container">
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="248px">
        <el-menu router :default-active="activeIndex">
          <el-submenu
            :index="iv.html"
            v-for="(iv, ivIndex) in menuList"
            :key="ivIndex"
          >
            <template slot="title">
              <!-- <i class="el-icon-location"></i> -->
              <el-image
                class="icon-submenu"
                alt=""
                :src="iv.severHttpUrl + iv.relativeIcon"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <span>{{ iv.name }}</span>
            </template>

            <el-menu-item
              :index="item.html"
              v-for="(item, index) in iv.menuList"
              :key="index"
              @click="setItemPath(item.html, iv.name)"
            >
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>

            <el-menu-item
              v-if="!iv.menuList"
              :index="iv.html"
              @click="setItemPath(iv.html, iv.name)"
            >
              <span slot="title">{{ iv.name }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <div class="main-box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>{{ metaTitle }}</el-breadcrumb-item>
          <el-breadcrumb-item class="metaTitleSub">{{
            metaTitleSub
          }}</el-breadcrumb-item>
        </el-breadcrumb>

        <el-main class="page-content-scroll">
          <router-view></router-view>
        </el-main>
      </div>
    </el-container>
  </div>
</template>
<script>
import { userpermissionsall, userpermissions } from '@/api/home'
export default {
  data() {
    return {
      // 二级菜单
      token: localStorage.getItem('token'),
      twoPermissionsMenu: [],
      // 处理默认高亮
      activeIndex: '',
      roleId: '',
      menuList: [],
      metaTitle: '',
      metaTitleSub: ''
    }
  },
  created() {
    // this.userpermissionsall()
    this.userpermissions()
    // 初始化时取出保存的页面路径
    this.setItemPath()
    this.activeIndex = window.sessionStorage.getItem('activeIndex')
  },

  methods: {
    //根据角色查询权限菜单

    async userpermissions() {
      this.roleId = localStorage.getItem('roleId')
      const { data: res } = await userpermissions({
        appCode: 'JCSJGL',
        roleId: this.roleId
      })

      this.menuList = res.data
      // this.twoPermissionsMenu = res.data[0].menuList
    },
    // //  调用权限列表接口
    // async userpermissionsall() {
    //   const { data: res } = await userpermissionsall({
    //     appCode: 'JCSJGL',
    //     parentId: 0,
    //   })
    //   // console.log(res);
    //   this.twoPermissionsMenu = res.data[0].menuList
    // },
    // 处理默认高亮
    setItemPath(activeIndex, name) {
      const { path, meta, matched } = this.$route
      this.metaTitleSub = meta.title

      if (name) {
        this.metaTitle = name
      } else {
        let obj = matched.find(item => item.path === path)
        this.metaTitle = obj ? obj.parent.meta.title : ''
        if (path == '/school/notice') {
          this.metaTitle = '公告管理'
        }
      }

      if (!activeIndex) {
        let timeur = setTimeout(() => {
          const roleType = localStorage.getItem('roleType')
          // console.log('roleType', roleType)
          if (this.roleId == '-1003') {
            // window.sessionStorage.setItem('activeIndex','/school/classes')
            this.activeIndex = '/school/classes'
          }
        }, 1000)
      }
      if (this.roleId == '-1003') {
        window.sessionStorage.setItem('activeIndex', activeIndex)
        // this.activeIndex = '/school/classes'
      }

      if (path == '/school/info') {
        window.sessionStorage.setItem('activeIndex', '/school/info')
      }

      this.activeIndex = activeIndex
      window.sessionStorage.setItem('activeIndex', path)
    }
  }
}
</script>
<style>
.el-breadcrumb {
  margin-bottom: 25px;
}
.el-breadcrumb__inner {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
}
.metaTitleSub .el-breadcrumb__inner {
  color: #2058ff !important;
}
.icon-submenu {
  width: 15px;
  height: 15px;
}
.icon-submenu .image-slot {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-submenu .image-slot i {
  width: 15px;
  height: 15px;
}
.icon-submenu .image-slot .el-icon-picture-outline:before {
  font-size: 14px;
}
</style>
<style scoped>
.main_container {
  height: 100%;
}

.el-container {
  height: 100%;
  background-color: #f7f7f7;
}
</style>



// WEBPACK FOOTER //
// src/views/school/index.vue